// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()

// We will just require channels as needed
//require('channels')

require("@popperjs/core")
import * as bootstrap from 'bootstrap';

require('dynamic_forms')
require('set_drop_downs')
require('recaptcha_check')

require('cookies_eu')
require('browser_warning')

require('billing_address_form')
require('card_form')

require('clipboard')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")

require("corp-notifications")

require('color_scheme_switcher')

require('multi_file_input')

require('photo_lightbox')
